<template>
  <el-dialog
    title="通用二维码"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="45%"
  >
    <div class="demo-image" v-for="(item, index) in machineids" :key="index">
      <!-- <div class="block" v-for="image in imageList" :key="image">
        <el-image
          style="width: 200px; height: 200px"
          :src="image.url"
        ></el-image>
        <div class="demonstration">{{ image.id }}</div>
        <div class="demonstration">----------------------</div>
      </div> -->

      <vue-qr
        :text="'https://www.joyinlaundry.com/qrcode?mid=' + item"
        :margin="5"
        :size="200"
      ></vue-qr>
      <div>{{ item }}</div>
    </div>
  </el-dialog>
</template>

<script>
////import { mapGetters } from "vuex";
import VueQr from "vue-qr";

export default {
  components: {
    VueQr
  },
  props: {
    machineids: {
      default: null
    }
  },
  data() {
    return {
      //sites: [{ name: "Runoob" }, { name: "Google" }, { name: "Taobao" }]
      //imageList: []
    };
  },
  methods: {
    closeForm() {
      this.$emit("closeForm");
    }
  },

  computed: {},
  mounted() {
    // this.imageList = this.imageIDs.map(ele => {
    //   return {
    //     id: ele,
    //     url: "/api/shared/wxacode?scene=a-" + ele
    //   };
    // });

    console.log("mmmmmmmmmmmm");
    console.log(this.machineids);
    // console.log(this.imageUrl);
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 202px;
}

.demo-image {
  background-color: #cdcdcdf2;
  margin-bottom: 20px;
  text-align: center;
}
</style>
